import { render, staticRenderFns } from "./appEduCourses.vue?vue&type=template&id=e42e911a&scoped=true"
import script from "./appEduCourses.vue?vue&type=script&lang=js"
export * from "./appEduCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42e911a",
  null
  
)

export default component.exports